import { Pipe, PipeTransform } from '@angular/core';
import {PropertiesQuery} from "common-shared";
import {map} from "rxjs/operators";
import {Observable} from "rxjs";
import {SpecLineModel} from "../../properties/models/spec-line.model";

@Pipe({
  name: 'specsByGroup'
})
export class SpecsByGroupPipe implements PipeTransform {
  constructor(private propertiesQuery: PropertiesQuery) {
  }

  transform(values: SpecLineModel[], groupClv: string, include: boolean = true) : Observable<SpecLineModel[]> {
    if (groupClv === null) return;
    return this.propertiesQuery.selectAll$.pipe(map(properties => {
      let ids = properties.filter(p => p.GroupClv === groupClv).map(p => p.Id);
      if (include) {
        return values.filter(value => SpecsByGroupPipe.isInGroup(value, ids, groupClv));
      }
      return values.filter(value => !SpecsByGroupPipe.isInGroup(value, ids, groupClv));
    }));
  }

  private static isInGroup(value: SpecLineModel, ids: string[], groupClv: string) {
    return (value.GroupClv === null && ids.includes(value.PropertyId)) || value.GroupClv === groupClv;
  }
}
